import { api } from 'common';
import { FlowDefinition } from 'vivaa-api';

import { HieGetDocumentsFormFields } from './FormFields';
import { HieGetDocumentsBlockDocumentationMarkdown } from './documentation';
import type { BlockConfigProps } from '../../types';

const { DurationUnits, HieGetDocuments } = FlowDefinition;
type DurationUnits = FlowDefinition.DurationUnits;

export const hieGetDocumentsConfig: BlockConfigProps<
  api.FlowDefinition.HieGetDocuments.HieGetDocumentsBlock['config']
> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'hieGetDocuments',
  defaultConfig: {
    sourceBlock: {
      sourceBlockName: '',
    },
    resources: [],
    includeRelatedRecords: false,
    documentFormat: HieGetDocuments.HieDocumentFormat.ConsolidatedData,
    dateFrom: '',
    dateTo: '',
    timeout: {
      value: 10,
      units: DurationUnits.Minutes,
    },
  },
  configFields: {
    schema: api.FlowDefinition.HieGetDocuments.HieGetDocumentsBlockConfigSchema,
    FormFields: HieGetDocumentsFormFields,
  },
  documentationMarkdown: HieGetDocumentsBlockDocumentationMarkdown,
};
